(ns rothko.component.on-click-out
  (:require ["react" :rename {createRef create-ref}]
            [reagent.core :as r]
            [rothko.dom.input :as input]))

(defn with-on-click-out
  [{:keys [on-click-out]} component]
  (let [ref (create-ref)
        body-on-click-handler (fn [event]
                                (when-not (.contains
                                           (.-current ref)
                                           (input/click->dom event))
                                  (on-click-out)))]
    (r/create-class
     {:component-did-mount
      (fn []
        (-> js/document
            .-body
            (.addEventListener
             "click"
             body-on-click-handler)))
      :component-will-unmount
      (fn []
        (-> js/document
            .-body
            (.removeEventListener
             "click"
             body-on-click-handler)))
      :reagent-render
      (fn [props & children]
        (into [component (merge props {:ref ref})] children))})))
